var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    stroke: "#e60000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m26 12.53 9e-4 2e-4 -5.124 4.993-0.3766 0.367 0.0888 0.5182 1.209 7.0529-6.333-3.329-0.4653-0.2446-0.4653 0.2446-6.333 3.329h-7e-5l1.209-7.0529 0.08883-0.5182-0.37656-0.367-5.124-4.993 9.5e-4 -2e-4 7.081-1.029 0.5199-0.0755 0.2327-0.471 3.1419-6.357c0.0022-0.00204 0.0047-0.00383 0.0073-0.00534 0.0062-0.00354 0.0132-0.00541 0.0204-0.00541 0.0071 0 0.0141 0.00187 0.0203 0.00541 0.0026 0.00149 5e-3 0.00325 0.0072 0.00525l3.1356 6.3564 0.2327 0.4716 0.5204 0.0756z",
    stroke: "#ffd600",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "translate(3 3)",
    width: 24,
    height: 24,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.aaa4d9005c36850da7b16b2651ff1574.svg";
export { ForwardRef as ReactComponent };